// Bridges studio:fileAssetUploaded CustomEvent → POST /api/file-assets (DB record).
// Base64 is NOT forwarded; it already lives in Yjs images Y.Map.
// The DB record links slot + style_id for ExtractionResult FK and audit trail.

import { getFreshToken } from '../auth.js';

export interface FileAssetUploadedPayload {
  slot: string;
  sourcePanel: 'chat' | 'form';
  base64: string;    // consumed locally for preview; not sent to server
  fileType: string;
}

export interface FileAssetRecord {
  id: string | null;   // null when DB row creation deferred (202 response)
  slot: string;
  styleId: string;
  sourcePanel: 'chat' | 'form';
}

export async function registerFileAsset(
  payload: FileAssetUploadedPayload,
  styleId: string,
  bomId?: string,
): Promise<FileAssetRecord | null> {
  try {
    const token = await getFreshToken() ?? '';
    const res = await fetch('/api/file-assets', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({
        styleId,
        slot: payload.slot,
        sourcePanel: payload.sourcePanel,
        fileType: payload.fileType,
        bomId: bomId ?? null,
      }),
    });
    if (!res.ok && res.status !== 202) return null;
    return await res.json() as FileAssetRecord;
  } catch {
    return null;
  }
}
